import { Component, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml, SafeStyle } from '@angular/platform-browser';


import { CoreService } from '../core.service';
import { ScheduleService } from '../schedule/schedule.service';
import { PlayerService } from './player.service';

@Component({
	selector: 'app-poster',
	imports: [ CommonModule ],
	templateUrl: './poster.component.html',
	styleUrl: './poster.component.scss'
})
export class PosterComponent {


	constructor(
		public core: CoreService,
		private schedule: ScheduleService,
		private player: PlayerService,
		private sanitizer: DomSanitizer,
	){}

	close = output<void>();
	open = output<void>();

	subscriptions = [];
	ngOnInit(){
		this.core.component_poster = this;

		this.subscriptions.push( this.core.stateshot_synced.subscribe( () => this.check_for("instant") ) );
		this.subscriptions.push( this.core.events.subscribe( (e) => this.check_for(e) ) );

		setTimeout(() => {
			this.check_for( "startup" );
		}, 100);
	}
	ngOnDestroy(){
		for( let sub of this.subscriptions ) sub.unsubscribe();
	}

	cooldowns: { [key: string]: number; }
	cooldowns_load(){
		this.cooldowns = JSON.parse(localStorage['poster_cooldowns'] || "{}");
	}
	cooldowns_set( id: string, timestamp: number ){
		this.cooldowns[id] = timestamp;

		//Stop tracking cooldowns older than an hour
		let delete_threshold = this.schedule.clock_timestamp - 3600000;

		for( let [k, v] of Object.entries(this.cooldowns) )
			if( v < delete_threshold ) delete this.cooldowns[k];

		localStorage['poster_cooldowns'] = JSON.stringify( this.cooldowns );
	}

	check_for_timeout_per_activation = {};
	check_for( event_type ){
		//console.log("[POSTER] Checking for", event_type)

		for( let poster of this.core.posters ){

			//Fully Ignore expired posters
			if( poster.is_expired ) continue

			//We do it this way, to take advantage of the schedule's clock fixing feature
			let activates_in_ms = poster.activation_datetime.getTime() - this.schedule.clock_timestamp;
			if( 0 < activates_in_ms ){

				//Converting 'instant' events coming from stateshot_syncs into 'activation' events.
				if( event_type == "instant" && poster.event_types.hasOwnProperty("activation") ){

					let current_timeout = this.check_for_timeout_per_activation[poster.id];

					if( current_timeout )
						clearTimeout( current_timeout );

					this.check_for_timeout_per_activation[poster.id] = setTimeout(
						() => this.check_for("activation"),
						activates_in_ms + 1000
					);

				}
				continue
			}

			if( !poster.event_types.hasOwnProperty( event_type ) ) continue

			this.cooldowns_load(); //Load this each time, in case we have more than one tabs open.
			let cooldown_timestamp = this.cooldowns[poster.id] || 0;
			if( this.schedule.clock_timestamp < cooldown_timestamp )
				continue

			this.select( poster, poster.event_types[event_type] );

			//Set the cooldown
			if( poster.cooldown_seconds )
				this.cooldowns_set( poster.id, this.schedule.clock_timestamp + poster.cooldown_seconds * 1000 );

			//Posters are ordered, so the first match is the correct one.
			return;
		}

		if( this.statics.has( event_type ) ){
			this.static_selected = event_type;
			this.open.emit();
		}
	}

	static_selected: string = null;
	statics = new Set([
		"paywall",
	]);

	style: SafeStyle;
	html: SafeHtml;
	select( poster, is_intrusive ){
		let subid = poster.id.split(":")[0];

		this.static_selected = this.statics.has( subid ) ? subid : null;
		this.html = this.sanitizer.bypassSecurityTrustHtml( poster.html );
		this.style = this.sanitizer.bypassSecurityTrustStyle( `background-image: URL(${poster.image});` );

		if( is_intrusive ){
			this.open.emit();
			return ;
		}

		if( !this.player.is_any_player_playing() )
			this.open.emit();
	}



}
